import HiddenTrigger from './hidden';
import Trigger from './main';

export default Trigger;
export { HiddenTrigger };
